import _ from 'lodash'
import moment from 'moment'
import ProvidersStore from '../../../services/providers/ProvidersStore';
import {googleListingManagementAllowed} from "../../../modules/app/site/featureAccessControl";


angular.module('clientDashboardApp').directive('listingMatch', function(){

  return {
    restrict: 'E',
    scope: {
      listing: '=',
      listingMatchConfig: '=',
      onUpdate: '=',
      activeGoogleVerifications: '=',
      showVerifyListingWithGoogle: '@', // 'ListingSummary'
      showFoundListingHeader: '@', // 'ListingSummary' 'ListingOptimization'
      showDuplicateListingHeader: '@', // ListingDuplicates
      showPrimaryListingHeader: '@', // 'ListingPrimary',
      showEditButton: '@', // 'ListingPrimary' 'ListingSummary' 'ListingOptimization'
      showEditMismatch: '@', // 'ListingSummary' 'ListingOptimization'
      showCategories: '@', // 'ListingSummary' 'ListingOptimization'
      showDescription: '@', // 'ListingSummary',
      showListingUrl: '@', // 'ListingBestMatch' 'ListingDuplicates' 'ListingPrimary'
      showExpectedListing: '@' // ListingPrimary, ListingBestMatch, ListingOptimization, ListingSummary,
    },
    controller: 'listingMatchController',
    template: require('./ListingMatch.html')
  }
});


angular.module('clientDashboardApp').controller('listingMatchController',
  (
    $scope, phoneNumberFilter, listingService, confirmService,
    locationService, decodeURIComponentFilter, providerService
  ) => {

  $scope.maybeActiveGoogleVerification = ($scope.activeGoogleVerifications || [])
      .find(verification => verification.chatmeterListingId === $scope.listing.listingId)

  $scope.googleListingManagementAllowed = googleListingManagementAllowed()
  // possible sources = ListingPrimary, ListingDuplicates, ListingBestMatch, ListingOptimization, ListingSummary

  const addProtocol = (url) => {
    if (!_.isString(url)) {
      return null;
    } else if (url.indexOf('//') === 0) {
      return url
    } else if (url.indexOf('.') === -1) { // must be garbage if no TLD
      return null;
    } else if (url.toLowerCase().indexOf('http') !== 0) {
      return 'http://' + url // attempt to clean protocol
    } else {
      return url
    }
  }
  $scope.cleanLink = (x) => {
    const clean = addProtocol(x)
    return clean && decodeURIComponentFilter(clean) || null;
  };
  $scope.provider = ProvidersStore.getProvider($scope.listing.contentProvider);
  //TODO: figure outsome race condition happening here that's causing this to not load reliably
  $scope.displaySettings = $scope.provider ? $scope.provider.displaySettings : {};

  // HACK TO HIDE BING FROM THE UI
  // TODO: Remove it when LLM team fix hours on Bing for all clients
  let providersToIgnore = ["BING"];
  if(!!providersToIgnore.includes($scope.provider.id)){
    $scope.listing.scrapedHoursSuccess = false;
    $scope.listing.foundHours = [];
   }
  $scope.isHoursProvider = ($scope.provider.id == 'GOOGLE') || !!$scope.listing.foundHours.length || !!$scope.listing.scrapedHoursSuccess;

  function refresh() {
    $scope.errorClass = "text-danger";
    $scope.warnClass = "text-warning";
    $scope.warnTooltip = "Matched alternate";

    $scope.foundAddress = $scope.listing.foundLocation;

    let location = $scope.listing.location
    let providerId = $scope.provider.id == 'GOOGLE' ? 'GOOGLEMAP' : $scope.provider.id
    $scope.expectedAddress = location && {
      ...location.businessAddress,
      phoneNumber: (location.listingManagementSpecs && location.listingManagementSpecs.providerTrackingNumbers && location.listingManagementSpecs.providerTrackingNumbers[providerId]) || location.phoneNumber,
      businessName: location.businessName
    } || null


    $scope.strings = {
      primaryListingTooltip : "The primary listing is the best listing we found that we use for monitoring reviews. \
      You can switch the primary listing with a duplicate listing using the Edit Url button."
    }


    if($scope.expectedAddress && $scope.expectedAddress.businessName){
      $scope.businessName = $scope.expectedAddress.businessName;
    }
    else{
      $scope.businessName = 'No Business Name Found';
    }


    const requiredFields = ['name', 'ignoreFlag', 'key'];

    function Field(options) {
      requiredFields.forEach(x => {
        if (!x in options) {
          throw `Missing required field ${x} in options ${options}`;
        }
      });
      return {
        isValueMissing: x => !x,
        displayFunction: x => x,
        required: true,
        hasError: matchErrors => !!(options.errors || []).find(x => matchErrors.indexOf(x) > -1),
        hasWarning: matchErrors => !!(options.warns || []).find(x => matchErrors.indexOf(x) > -1),
        errorText: "Mismatch",
        warnText: "Partial Mismatch",
        ...options
      }
    }

    $scope.days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

    $scope.fields = {
      businessName : Field({
        name: "Business Name",
        ignoreFlag: "BusinessName",
        key: "businessName",
        errors: ["BusNameMatch", "PartialBusNameMatch"],
        errorText: "Business Name Mismatch",
      }),
      website : Field({
        name: "Website",
        ignoreFlag: "Website",
        key: "website",
        errors: ["WebsiteMatch"],
        errorText: "Website Mismatch",
      }),
      street : Field({
        name: "Street",
        matchString: "StreetMatch",
        ignoreFlag: "Address",
        key: "street",
        errors: ["StreetMatch"],
        errorText: "Address Mismatch",
        warns: ["PartialStreetMatch"],
        warnText: "Partial Address Mismatch"
      }),
      city : Field({
        name: "City",
        ignoreFlag: "Address",
        key: "city",
        errors: ["CityMatch"],
        errorText: "City Name Mismatch",
      }),
      state: Field({
        name: "State",
        ignoreFlag: "Address",
        key: "state",
        errors: ["StateMatch"],
        errorText: "State Mismatch",
      }),
      suite : Field({
        required: false,
        name: "Suite",
        ignoreFlag: "Address",
        key: "suite",
        errors: ["SuiteMatch"],
        errorText: "Suite Mismatch",
      }),
      zip : Field({
        name: "Postal Code",
        ignoreFlag: "Address",
        key: "postalCode",
        errors: ["ZipMatch"],
        errorText: "Postal Code Mismatch",
      }),
      phone : Field({
        name: "Phone Number",
        displayFunction: xs => {
          return phoneNumberFilter(_.isArray(xs) ? xs[0] : xs)
        },
        ignoreFlag: "Phone",
        key: "phoneNumber",
        isValueMissing: xs => !xs || !xs[0],

        // TODO the mismatch data on the listing should be improved. This is all very hacky
        hasError: mismatches =>
          ["PhoneMatch", "NoAltPhone", "AltPhoneMatch"].filter(x => mismatches.indexOf(x) > -1).length > 1,
        errorText: "Phone Number Mismatch",
        warns: ["PhoneMatch"],
        warnText: "Matched Alternate",
      }),
      hours: Field ( {
        name: "Hours",
        ignoreFlag: "Hours",
        key: "hours",
        errors: ["HoursMatch"],
        errorText: "Hours Mismatch"
      })
    };

    $scope.mismatchIgnoreFlags = ["BusinessName", "Address", "Phone", "Website", "Hours"];
    $scope.mismatchDisplaySettings = {};

    if($scope.listing.foundURL){
      $scope.foundAddress.website = $scope.listing.foundURL;
    }
    if($scope.listing.expectedURL && $scope.expectedAddress){
        let providerId = $scope.provider.id == 'GOOGLE' ? 'GOOGLEMAP' : $scope.provider.id
        const expectedURL = location.listingManagementSpecs && location.listingManagementSpecs.providerTrackingWebsiteUrls && location.listingManagementSpecs && location.listingManagementSpecs.providerTrackingWebsiteUrls[providerId] || $scope.listing.expectedURL
        $scope.expectedAddress.websiteProps = {href: expectedURL, target: "_blank"};
    }
    if($scope.listing.foundHours) {
      $scope.foundAddress.hours = $scope.listing.foundHours;
    }
    if($scope.listing.expectedHours && $scope.expectedAddress) {
      $scope.expectedAddress.hours = $scope.listing.expectedHours;
    }

    $scope.makeReadableHours = function(hoursString) {
      return moment(hoursString, "HHmm").format("h:mmA")
    }

    function isIgnoredMismatchType(mismatchType) {
      return ($scope.listing.ignoredMismatchTypes || []).indexOf(mismatchType) >= 0
    }

    function populateErrorFields(){

      _.each($scope.fields, function(field) {
        const matchErrors = $scope.listing.matchErrors || [];
        const isIgnored = isIgnoredMismatchType(field.ignoreFlag);
        const hasError = field.hasError(matchErrors);
        const hasWarning = field.hasWarning(matchErrors);
        const isMissing = field.isValueMissing($scope.foundAddress[field.key]);
        const errorText = isIgnored ? null :
          isMissing ? 'No ' + field.name + ' Found' :
            hasError ? field.errorText :
              hasWarning ? field.warnText :
                null;
        const errorClass = isIgnored ? '' :
          hasError ? $scope.errorClass :
            hasWarning ? $scope.warnClass :
              '';

        field.foundErrors = { isIgnored, hasMismatch: hasError || hasWarning, errorText, errorClass }

      });
      $scope.mismatchDisplaySettings = $scope.mismatchIgnoreFlags
        .map(name => {
          const relevant = _.toArray($scope.fields).filter(x => x.ignoreFlag === name);
          const isIgnored = !!relevant.find(x => x.foundErrors.isIgnored);
          const hasMismatch = !!relevant.find(x => x.foundErrors.hasMismatch);
          const setting = {
            isIgnored,
            hasMismatch,
            updating: false,
            onClick: () => {
              setting.updating = true;
              if (isIgnored) {
                $scope.listing.ignoredMismatchTypes = $scope.listing.ignoredMismatchTypes.filter(x => x !== name)
              } else {
                $scope.listing.ignoredMismatchTypes = ($scope.listing.ignoredMismatchTypes || []).concat([name]);
              }
              listingService.updateIgnoredMismatchTypes(
                $scope.listing.listingId,
                $scope.listing.ignoredMismatchTypes
              ).then(x => {
                populateErrorFields()
              })
            },
            name
          }
          return setting
      }).reduce((sum, x) => ({ ...sum, [x.name]: x }), {})
    }

    function populateMissingFieldText(addressKey, field){
      let address = $scope[addressKey];
      if(!address) return;

      if (field.required && field.isValueMissing(address[field.key])) {
        address[field.key] = 'No ' + field.name;
      } else {
        address[field.key] = field.displayFunction(address[field.key]);
      }
    }

    function populateMissingFieldsText(){
      _.each($scope.fields, function(field){
        populateMissingFieldText('expectedAddress',field);
        populateMissingFieldText('foundAddress', field);
      });
    }

    populateErrorFields();
    populateMissingFieldsText();

  }

  if ($scope.listing) {
    refresh()
  }

  $scope.daysHoursMismatch = function(day) {
    if (!$scope.expectedAddress) {
      return false
    }
    else {
      const foundHours = $scope.foundAddress.hours
      const expectedHours = $scope.expectedAddress.hours
      return !_.isEqual(foundHours[day], expectedHours[day])
    }
  }

  $scope.hoursEmpty = function(hours) {
    return Object.keys(hours).length === 0 && hours.constructor === Object
  }

});

angular.module('clientDashboardApp').filter('decodeURIComponent', () => (text) => !text ? '' : decodeURIComponent(text))
